import React from 'react';
import '../styles/LoadingSpinner.css';

const ButtonSpinner = () => (
    <span className="button-spinner">•</span>
);

export default ButtonSpinner;